import formatISO from "date-fns/formatISO";
import subWeeks from "date-fns/subWeeks";
import api from "@/modules/common/api";
import { AlertLevels } from "@/modules/common/settings";
import * as consts from "./consts";

const initialState = {
  recents: [],
  itemDetails: null
};

const actions = {
  async initialize({ dispatch }) {
    await dispatch("getRecents");
  },
  async getRecents({ commit, rootState }) {
    const startDate = formatISO(subWeeks(new Date(), 1), {
      representation: "date"
    });

    const { data } = await api.getAlerts(rootState.common.source, {
      startDate
    });

    commit(consts.SET_RECENTS, data.items);
  },
  setItemDetails({ commit }, itemDetails) {
    commit(consts.SET_ITEM_DETAILS, itemDetails);
  }
};

const mutations = {
  [consts.SET_RECENTS](state, recents) {
    state.recents = recents;
  },
  [consts.SET_ITEM_DETAILS](state, itemDetails) {
    state.itemDetails = itemDetails;
  }
};

const getters = {};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters
};
